module.exports = __webpack_public_path__ + "img/hearth.7727e155.png";